import produce from 'immer'
import { t } from 'helpers/i18n'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import assetCategoryActions from 'actions/assetCategories'
import Component from 'components/Jobs/FormView/SelectAssetCategory'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(assetCategoryActions.getItems({ ...params })).then((r) =>
        produce(r, (draft) => {
          if (params.pageIndex <= 1 && !params.search) {
            draft.value.data.items.unshift({ id: 0, displayName: t('all') })
            draft.value.data.recordCount++
          }
        })
      ),
  }),
})(Component)
